import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';

import { EMPTY } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { ActivityService } from '../../home/services/activity.service';
import { resolveWorkspaceActivity } from '../workspace-activity-events';

/**
 * Reports successful workspace-gateway calls to the sdocs activity log, fire-and-forget: a
 * failed report is swallowed and never affects the intercepted call.
 */
export const workspaceActivityInterceptor: HttpInterceptorFn = (req, next) => {
  const activity = resolveWorkspaceActivity(req.method, req.url);
  if (!activity) {
    return next(req);
  }

  const activityService = inject(ActivityService);

  return next(req).pipe(
    tap((event) => {
      if (event instanceof HttpResponse) {
        activityService
          .addActivity(activity.event, activity.meta)
          .pipe(catchError(() => EMPTY))
          .subscribe();
      }
    }),
  );
};
